<template>
    <div class="flex items-end">
        <div
            class="text-brand-base flex cursor-pointer items-center justify-center space-x-1 text-center text-base transition duration-200 hover:scale-102"
            @click="() => buttonClicked()"
        >
            <slot />
        </div>
    </div>
</template>

<script setup>
import useButton, { buttonProps } from '@/lib/hooks/use-button'

const props = defineProps({ ...buttonProps })

let { active, onClick } = useButton()
const buttonClicked = () => {
    onClick({ action: props.action, to: props.to })
}
</script>
